import React from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useAuthStore } from '../store';

const guestRoutes = [
  '/login',
  '/signup',
  '/forgot-password',
  '/verified-email',
];

const GuestRoute: React.FC = () => {
  const { isAuthenticated } = useAuthStore();
  const location = useLocation();

  // If the user is authenticated and trying to access a guest route, redirect to dashboard
  if (isAuthenticated() && guestRoutes.includes(location.pathname)) {
    return <Navigate to="/dashboard" />;
  }

  // Render nested routes
  return <Outlet />;
};

export default GuestRoute;
